export default "__VITE_ASSET__a455acb2__"